export const SungeryColumns = [{
    title: 'SN',
    dataIndex: "SerialNumber",
    width: 160,
    fixed: 'left',
}, {
    title: 'CreateTime',
    dataIndex: 'CreateTime',
    width: 160,
    fixed: 'left',
}, {
    title: 'PAC1Inv(W)',
    dataIndex: 'PAC1Inv',
    width: 160,
}, {
    title: 'PAC2Inv(W)',
    dataIndex: 'PAC2Inv',
    width: 160,
}, {
    title: 'PAC3Inv(W)',
    dataIndex: 'PAC3Inv',
    width: 160,
}, {
    title: 'PDC(W)',
    dataIndex: 'PDC',
    width: 160,
}, {
    title: 'EDay(kWh)',
    dataIndex: 'EDay',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotal(kWh)',
    dataIndex: 'ETotal',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT1(V)',
    dataIndex: 'VMPPT1',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT1(A)',
    dataIndex: 'IMPPT1',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VMPPT2(V)',
    dataIndex: 'VMPPT2',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IMPPT2(A)',
    dataIndex: 'IMPPT2',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PMPPT1(W)',
    dataIndex: 'PMPPT1',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PMPPT2(W)',
    dataIndex: 'PMPPT2',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'VBat(V)',
    dataIndex: 'VBat',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IBat(A)',
    dataIndex: 'IBat',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'SOC',
    dataIndex: 'SOC',
    width: 160,
}, {
    title: 'EDayBatChrg(kWh)',
    dataIndex: 'EDayBatChrg',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalBatChrg(kWh)',
    dataIndex: 'ETotalBatChrg',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EDayBatDischrg(kWh)',
    dataIndex: 'EDayBatDischrg',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalBatDischrg(kWh)',
    dataIndex: 'ETotalBatDischrg',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'PAC1EPS(W)',
    dataIndex: 'PAC1EPS',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'PAC2EPS(W)',
    dataIndex: 'PAC2EPS',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'PAC3EPS(W)',
    dataIndex: 'PAC3EPS',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
},
{
    title: 'PAC1LOAD(W)',
    dataIndex: 'PAC1LOAD',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'PAC2LOAD(W)',
    dataIndex: 'PAC2LOAD',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'PAC3LOAD(W)',
    dataIndex: 'PAC3LOAD',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'VAC1LOAD(V)',
    dataIndex: 'VAC1LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC1LOAD(A)',
    dataIndex: 'IAC1LOAD',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'VAC2LOAD(V)',
    dataIndex: 'VAC2LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC2LOAD(A)',
    dataIndex: 'IAC2LOAD',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'VAC3LOAD(V)',
    dataIndex: 'VAC3LOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'IAC3LOAD(A)',
    dataIndex: 'IAC3LOAD',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'EDayLOAD(kWh)',
    dataIndex: 'EDayLOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalLOAD(kWh)',
    dataIndex: 'ETotalLOAD',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
},
{
    title: 'PAC1GRID(W)',
    dataIndex: 'PAC1GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'PAC2GRID(W)',
    dataIndex: 'PAC2GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'PAC3GRID(W)',
    dataIndex: 'PAC3GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'IAC1GRID(A)',
    dataIndex: 'IAC1GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'IAC2GRID(A)',
    dataIndex: 'IAC2GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'IAC3GRID(A)',
    dataIndex: 'IAC3GRID',
    width: 160,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'EDayFromGrid(kWh)',
    dataIndex: 'EDayFromGrid',
    width: 160,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalFromGrid(kWh)',
    dataIndex: 'ETotalFromGrid',
    width: 200,
    render: (v) => {
        const x = v * 0.1;
        return isNaN(x) ? "" : x.toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'Temp1(°C)',
    dataIndex: 'Temp1',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'Temp2(°C)',
    dataIndex: 'Temp2',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'Temp3(°C)',
    dataIndex: 'Temp3',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = (v - 0x10000);
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'Temp4(°C)',
    dataIndex: 'Temp4',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return (v * 0.1).toFixed(1); 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'ParallelBattSumPower(W)',
    dataIndex: 'ParallelBattSumPower',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelBackUpSumOutW_A(W)',
    dataIndex: 'ParallelBackUpSumOutW_A',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelBackUpSumOutW_B(W)',
    dataIndex: 'ParallelBackUpSumOutW_B',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelBackUpSumOutW_C(W)',
    dataIndex: 'ParallelBackUpSumOutW_C',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelBackUpSumOutVA_A(W)',
    dataIndex: 'ParallelBackUpSumOutVA_A',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelBackUpSumOutVA_B(W)',
    dataIndex: 'ParallelBackUpSumOutVA_B',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelBackUpSumOutVA_C(W)',
    dataIndex: 'ParallelBackUpSumOutVA_C',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelGeneratedSumPowerP_A(W)',
    dataIndex: 'ParallelGeneratedSumPowerP_A',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelGeneratedSumPowerP_B(W)',
    dataIndex: 'ParallelGeneratedSumPowerP_B',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelGeneratedSumPowerP_C(W)',
    dataIndex: 'ParallelGeneratedSumPowerP_C',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelNormalSumLoadW_A(W)',
    dataIndex: 'ParallelNormalSumLoadW_A',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelNormalSumLoadW_B(W)',
    dataIndex: 'ParallelNormalSumLoadW_B',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelNormalSumLoadW_C(W)',
    dataIndex: 'ParallelNormalSumLoadW_C',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelLineSumPowerW_A(W)',
    dataIndex: 'ParallelLineSumPowerW_A',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
        multiplicative_inverse: 10,
    }
}, {
    title: 'ParallelLineSumPowerW_B(W)',
    dataIndex: 'ParallelLineSumPowerW_B',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelLineSumPowerW_C(W)',
    dataIndex: 'ParallelLineSumPowerW_C',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelExtPvSumOutW_A(W)',
    dataIndex: 'ParallelExtPvSumOutW_A',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelExtPvSumOutW_B(W)',
    dataIndex: 'ParallelExtPvSumOutW_B',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
}, {
    title: 'ParallelExtPvSumOutW_C(W)',
    dataIndex: 'ParallelExtPvSumOutW_C',
    width: 240,
    render: (v) => {
        if (isNaN(v)) return ""
        if (v > 0x7fff) v = v - 0x10000;
        return v; 
    },
    transform: {
        signed: 0x7fff,
    }
},{
    title: 'EDayToCT(kWh)',
    dataIndex: 'EDayToCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
},{
    title: 'EDayFromCT(kWh)',
    dataIndex: 'EDayFromCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EMonthToCT(kWh)',
    dataIndex: 'EMonthToCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
},{
    title: 'EMonthFromCT(kWh)',
    dataIndex: 'EMonthFromCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'EYearToCT(kWh)',
    dataIndex: 'EYearToCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10 
    }
},{
    title: 'EYearFromCT(kWh)',
    dataIndex: 'EYearFromCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}, {
    title: 'ETotalToCT(kWh)',
    dataIndex: 'ETotalToCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
},{
    title: 'ETotalFromCT(kWh)',
    dataIndex: 'ETotalFromCT',
    width: 200,
    render: (v) => {
        return (v * 0.1).toFixed(1);
    },
    transform: {
        multiplicative_inverse: 10
    }
}];